<template>
  <v-layout
    align-center
    align-content-center
    justify-center
    column
    style="margin-top: 200px"
  >
    <!-- <Authenticator></Authenticator> -->

    <template v-if="!loggedOut">
      <v-icon color="green" size="100">mdi-account</v-icon>
      <h2 class="logInTitle">Log Out</h2>
      <v-card-subtitle
        >You are being logged out. Please wait...</v-card-subtitle
      >
    </template>
    <template v-else>
      <v-icon color="green" size="100">mdi-account</v-icon>
      <h2 class="logInTitle">Logged Out</h2>
      <v-card-subtitle
        >You have been logged out. You may now close this tab.</v-card-subtitle
      >
    </template>

    <v-progress-circular
      indeterminate
      color="green"
      v-if="waitFlag"
      size="50"
    ></v-progress-circular>

    <modal
      name="errorModal"
      :draggable="true"
      :clickToClose="false"
      :height="200"
      :width="450"
    >
      <v-card style="height: 200px; width: 450px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Error</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          Something went wrong. Please try again. If the error persists, please
          contact support.
        </v-card-subtitle>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('errorModal');
              $router.push('/logout');
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>
  </v-layout>
</template>
<script>
import { Auth } from "aws-amplify";
import EventBus from "@/eventBus.js";
import { HTTP } from "@/http-common.js";
import utilityMixins from "@/utility-mixins.js";
import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "@/graphql/mutations";

export default {
  mixins: [utilityMixins],
  data() {
    return {
      waitFlag: false,
      loggedOut: false
    };
  },
  computed: {
    userPrimaryAgentNum() {
      let agentNum;

      if (this.isAgencyUser)
        agentNum = window.sessionStorage.getItem("primaryAgentNum");

      if (!this.isAgencyUser || !agentNum || agentNum == "null")
        agentNum = this.$store.state.currentUser.agentNum;

      return agentNum;
    }
  },
  created() {
    this.waitFlag = true;
    let jwt = window.sessionStorage.getItem("jwt");
    if (jwt == "invalid_jwt") {
      this.waitFlag = false;
      this.$router.push("/unauthenticated");
    }
  },
  mounted() {
    let jwt = window.sessionStorage.getItem("jwt");
    let accessCode = window.sessionStorage.getItem("accessCode");

    if (
      (jwt == null || jwt == undefined) &&
      (accessCode == null || accessCode == undefined)
    ) {
      if (
        this.userPrimaryAgentNum != null &&
        this.userPrimaryAgentNum != undefined
      ) {
        HTTP.post(
          "bulkunlock",
          {
            editedByNum: this.userPrimaryAgentNum
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
          .then(async results => {
            let retHiers = results.data;

            if (retHiers && retHiers.length) {

              for (let retHier of retHiers) {

                this.$store.commit("setBroadcastUnlock", true);
                this.$store.commit("setUnlockedHier", retHier.AO);

                await API.graphql(
                  graphqlOperation(mutations.broadcastUnlock, {
                    input: {
                      AOAgentNum: retHier.AO,
                      Msg: "The hierarchy is now unlocked.",
                      Editing: false,
                      From: this.$store.state.currentUser.agentNum,
                      FromName: "AMT",
                      To: "AMT USER",
                      FromSession: this.$store.state.session,
                      ToSession: retHier.Session
                    }
                  })
                ).catch(e => {
                  this.addToErrorLogs(
                    "App.vue sendReplyMsg broadcastUnlock",
                    e
                  );
                  this.overlay = false;
                  this.$modal.show("errorModal");
                  return;
                });
              }
            }
          })
          .catch(e => {
            this.addToErrorLogs("logout mounted POST /bulkunlock", e);
          });
      }
    }

    if (jwt == "invalid_jwt") {
      this.waitFlag = false;
      this.$router.push("/unauthenticated");
    }
    this.$store.commit("setCurrentUser", null);
    window.sessionStorage.removeItem("currentUser");

    EventBus.$emit("setUserName", null);

    this.$store.commit("setUserRoles", null);
    window.sessionStorage.removeItem("primaryAgentNum");

   if (jwt != null) {
      this.$store.commit("setJWT", "invalid_jwt");
      window.sessionStorage.setItem("jwt", "invalid_jwt");
    }
    // this.$store.commit("setJWT", null);
    // window.sessionStorage.removeItem("jwt");

    this.$store.commit("setAccessCode", null);
    window.sessionStorage.removeItem("accessCode");

    this.$store.commit("setTmkClientId", null);
    window.sessionStorage.removeItem("tmkClientId");

    EventBus.$emit("setIsJWTAuthenticated", false);

    if (jwt != null || accessCode != null) {
      EventBus.$emit("logOutJWT");
      setTimeout(() => {
        this.waitFlag = false;
        this.loggedOut = true;
      }, 2000);
    } else {
      Auth.signOut()
        .then(() => {
          setTimeout(() => {
            this.$router.push("/login");
          }, 3000);
        })
        .catch(() => {
          this.$router.push("/login");
        });
    }
  }
};
</script>
